<template>
    <edit-selection
        ref="input"
        v-model="inputValue"
        form
        :disabled="disabled"
        :required="required"
        :rules="rulesValue"
        :error-messages="errorMessagesValue"
        :label="labelValue"
        :items="items"
        :autocomplete="false"
        :loading="loading"
        :hide-details="hideDetails"
    >
        <template #append>
            <slot name="append" />
        </template>
        <template #append-outer>
            <slot name="append-outer" />
        </template>
    </edit-selection>
</template>

<script>
import BaseField from './BaseField';

export default {
    name: 'Options',
    extends: BaseField,
    props: {
        exclude: {
            type: Array,
            default: () => []
        },
        items: {
            type: Array,
            default: () => [
                {
                    text: 'Yes',
                    value: true
                },
                {
                    text: 'No',
                    value: false
                }
            ]
        }
    }
};
</script>
